import { DropdownButton } from '@dixa/lib-shared-habla';
import { AsyncStatus } from 'lib-shared-legacy-types';
import { Component } from 'react';

import AutocompleteUserCcBcc from './AutocompleteUserCcBcc';
import UserEmailOption from './UserEmailOption';

import '../styles/listUserEmailOptions.less';

type PropsT = {
  fieldLabel: string;
  availableOptions: Array<any>;
  singleChoice: boolean | null;
  required: boolean | null;
  status: AsyncStatus;
  className: string | null;
  elementItem: any;
  getfunction: () => Promise<any>;
  touchOnChange: ((isTouched: boolean) => void) | null;
  touch: (form: string, field: string) => void;
  stopFormSubmit: ((form: string, errors: any) => void) | null;
  placeholder: string | null;
  error: string | null;
  showSearch: boolean;
} & any;

type StateT = {
  active: boolean;
};

const PREVIEW_LIMIT_EMAIL = 3;

class ListUserEmailOptionsCcBcc extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);
    this.state = {
      active: false,
    };
  }

  onFocusFunction = () => {
    this.setState({ active: true });
  };

  onBlurFunction = () => {
    this.setState({ active: false });
  };

  getDropdownContent(selectedOptions: Array<any>) {
    const { fields, fieldLabel } = this.props;
    return (
      <div className="dropdown-content-wrapper">
        {selectedOptions
          .filter((contactField) => typeof contactField.email === 'string')
          .map((contactField: any, index: number) => {
            if (PREVIEW_LIMIT_EMAIL <= index) {
              return (
                <UserEmailOption
                  key={`cc-bcc-extra-${contactField.email}-${index}`}
                  removable={true}
                  fieldLabel={fieldLabel}
                  contactField={contactField}
                  fields={fields}
                  index={index}
                  change={this.props.change}
                />
              );
            }
            return null;
          })
          .filter((q) => q !== undefined)}
      </div>
    );
  }

  render() {
    const {
      fields,
      fieldLabel,
      showSearch,
      meta: { touched, submitFailed, error, valid, form, pristine },
      availableOptions,
      singleChoice,
      touch,
      className,
      placeholder,
    } = this.props;
    const hasError = (touched || submitFailed) && error ? 'has-error' : '';
    const hasSuccess = valid && pristine === false ? 'has-success' : '';

    let isSearchShown = true;
    const selectedOptions: any[] = [];
    let noneFoundMessage = 'None found';
    let formGroupClasses =
      className && typeof className === 'string' ? className : '';

    fields.map((field: any, index: number) => {
      const f = fields.get(index);
      selectedOptions.push(f.user);
    });

    let filteredFields = availableOptions.map((x) =>
      Object.assign(
        {},
        x,
        selectedOptions.find((y) => y.id == x.id),
      ),
    );

    if (selectedOptions.length > 0 && singleChoice === true) {
      filteredFields = [];
      isSearchShown = false;
      noneFoundMessage =
        'Only a single choice can be selected. Remove the selected choice if you want another.';
    }

    if (availableOptions === null) {
      filteredFields = [];
    }

    if (this.state.active === true) {
      formGroupClasses += ' focused';
    }

    if (singleChoice === true) {
      formGroupClasses += ' single-choice';
    }

    return (
      <div
        className={`list-user-options-fields user-options-styled-cc-bcc ${formGroupClasses} ${hasSuccess} ${hasError}`}
      >
        {selectedOptions.map((contactField, index: number) => {
          if (index < PREVIEW_LIMIT_EMAIL) {
            return (
              <UserEmailOption
                key={`cc-bcc-${contactField.email}-${index}`}
                removable
                fieldLabel={fieldLabel}
                contactField={contactField}
                fields={fields}
                index={index}
                change={this.props.change}
              />
            );
          }
          return null;
        })}
        {selectedOptions.length > PREVIEW_LIMIT_EMAIL && (
          <DropdownButton
            noArrow
            noStyle
            dropdown={this.getDropdownContent(selectedOptions)}
            className="dropdown-extra-cc-bcc-wrapper"
          >
            {`+${selectedOptions.length - PREVIEW_LIMIT_EMAIL} more...`}
          </DropdownButton>
        )}
        {showSearch && (
          <AutocompleteUserCcBcc
            touch={touch}
            stopFormSubmit={this.props.stopFormSubmit}
            isShown={isSearchShown}
            formName={form}
            fieldLabel={fieldLabel}
            noneFoundMessage={noneFoundMessage}
            getfunction={this.props.getfunction}
            placeholder={placeholder}
            elements={filteredFields}
            ElementItem={this.props.elementItem}
            onFocusFunction={this.onFocusFunction}
            onBlurFunction={this.onBlurFunction}
            status={this.props.status}
            add={fields.push}
            error={fields.error}
            fields={fields}
          />
        )}
      </div>
    );
  }
}

export default ListUserEmailOptionsCcBcc;
